import { createAsyncThunk } from "@reduxjs/toolkit";

import { EventTravelLegService } from "Bands/services";
import {
  BAND_ACTIONS,
  IEventTravelLegParams,
  TravelLegType,
} from "Bands/types";
import { getTravelLegApiEndpoint, getTravelLegDataKey } from "Bands/utils";
import { API_ENDPOINTS } from "shared/constants";
import { getIdFromPath } from "shared/utils";
import { dispatchGetEventTravelBlock } from "./eventTravelBlock";
import { dispatchGetTravelBlockPassengers } from ".";

export const createTravelLeg = createAsyncThunk(
  BAND_ACTIONS.createTravelLeg,
  async (
    {
      data,
      travelLegType,
    }: { data: IEventTravelLegParams; travelLegType: TravelLegType },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response = await EventTravelLegService.createTravelLeg({
        data,
        travelLegType,
      });

      // refetch block on create/edit/delete
      if (data.travelBlock) {
        dispatchGetEventTravelBlock(
          dispatch,
          getIdFromPath(data.travelBlock, API_ENDPOINTS.EVENT_TRAVEL_BLOCKS)
        );
      }

      return { data: response };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editTravelLeg = createAsyncThunk(
  BAND_ACTIONS.editTravelLeg,
  async (
    {
      id,
      data,
      blockId,
      travelLegType,
    }: {
      id: string;
      data: IEventTravelLegParams;
      blockId: string;
      travelLegType: TravelLegType;
    },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response = await EventTravelLegService.editTravelLeg({
        id,
        data,
        travelLegType,
      });

      // refetch block on create/edit/delete
      dispatchGetEventTravelBlock(dispatch, blockId);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteTravelLeg = createAsyncThunk(
  BAND_ACTIONS.deleteTravelLeg,
  async (
    {
      id,
      blockId,
      travelLegType,
    }: { id: string; blockId: string; travelLegType: TravelLegType },
    { rejectWithValue, dispatch }
  ) => {
    try {
      await EventTravelLegService.deleteTravelLeg({ id, travelLegType });

      // refetch block on create/edit/delete
      dispatchGetEventTravelBlock(dispatch, blockId);
      dispatchGetTravelBlockPassengers({ dispatch, blockId });

      return {
        path: getTravelLegApiEndpoint(travelLegType).item(id),
        dataKey: getTravelLegDataKey(travelLegType),
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
